import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import useCartContext from "@Hooks/useCartContext";
import { goToCategories, goToDrafts } from "@Utils/navigation";
import { setDataLayerTrack } from "@Utils/track";
import { ReactComponent as IconBag } from "./bag.svg";

import "./style.scss";

interface Props {
  userHasDraft: boolean;
}

export const CartEmpty: FunctionComponent<Props> = ({ userHasDraft }) => {
  const intl = useIntl();
  const type = userHasDraft ? "withDraft" : "withoutDraft";

  const handleClick = () => {
    if (userHasDraft) {
      goToDrafts(intl.locale);
    } else {
      setDataLayerTrack("Product List Clicked", {
        categoryPageTag: "all",
        linkPosition: "Empty Cart",
      });
      goToCategories(intl.locale, "all");
    }
  };

  return (
    <div className="CartEmpty">
      <IconBag />
      <div className="CartEmpty-title">
        {intl.formatMessage({ id: `cheerz_CartEmpty_title__${type}` })}
      </div>
      <div className="CartEmpty-description">
        {intl.formatMessage({ id: `cheerz_CartEmpty_description__${type}` })}
      </div>
      <ButtonSmily onClick={handleClick} size="m" type="primary">
        {intl.formatMessage({ id: `cheerz_CartEmpty_button__${type}` })}
      </ButtonSmily>
    </div>
  );
};

const CartEmptyContainer: FunctionComponent = () => {
  const { ui } = useCartContext();

  return <CartEmpty userHasDraft={ui.draftsNumber > 0} />;
};

export default CartEmptyContainer;
